export default class Utils {
  public static localeFormatter(
    value: number | string,
    maximumFractionDigits: number = 0
  ): string {
    return value.toLocaleString(navigator.language, {
      minimumFractionDigits: 0,
      maximumFractionDigits,
    });
  }

  public static round(num: number): number {
    var m = Number((Math.abs(num) * 100).toPrecision(15));
    return (Math.round(m) / 100) * Math.sign(num);
  }

  public static range(size: number, startAt: number = 0) {
    return [...Array(size).keys()].map((i) => i + startAt);
  }

  public static clone(object: any) {
    return JSON.parse(JSON.stringify(object));
  }

  public static truncate(str: string, length: number): string {
    return str.length > length
      ? str.substring(0, length - 1) + "&hellip;"
      : str;
  }
}
